<div class="container_cateogry">
  <div class="category_banner-img">
    @switch (slug) {
      @case ("artoys") {
        <img src="./assets/img/banner_artoys_category.webp" alt="banner" class="d-none d-md-block" />
        <img src="./assets/img/banner_artoys_category_mobile.webp" alt="banner" class="d-md-none" />
      }
      @case ("sofubi") {
        <img src="./assets/img/banner_sofubi_category.webp" alt="banner" class="d-none d-md-block" />
        <img src="./assets/img/banner_sofubi_category_mobile.webp" alt="banner" class="d-md-none" />
      }
      @case ("gachapon") {
        <img src="./assets/img/banner_gachapon_category.webp" alt="banner" class="d-none d-md-block" />
        <img src="./assets/img/banner_gachapon_category_mobile.webp" alt="banner" class="d-md-none" />
      }
      @case ("blindbox") {
        <img src="./assets/img/banner_blindbox_category.webp" alt="banner" class="d-none d-md-block" />
        <img src="./assets/img/banner_blindbox_category_mobile.webp" alt="banner" class="d-md-none" />
      }
      @default {
        <img src="./assets/img/banner_all_category.webp" alt="banner" />
      }
    }

    <div class="dark_opacity"></div>
    <div class="category_banne-text">
      <h1>
        @switch (slug) {
          @case ("artoys") {
            Art Toys
          }
          @case ("sofubi") {
            Sofubi
          }
          @case ("gachapon") {
            Gachapon
          }
          @case ("blindbox") {
            BlindBox
          }
        }
      </h1>
    </div>
  </div>
  <div class="menu_category">
    <ul class="ps-0">
      <!-- @if (slug!=='artoys') { -->

      <li [class.active]="slug === 'artoys'">
        <a [routerLink]="['/category', 'artoys']"> Art Toys </a>
      </li>

      <!-- } -->
      <!-- @if (slug!=='sofubi') { -->

      <li [class.active]="slug === 'sofubi'">
        <a [routerLink]="['/category', 'sofubi']"> Sofubi </a>
      </li>

      <!-- } -->
      <!-- @if (slug!=='gachapon') { -->

      <li [class.active]="slug === 'gachapon'">
        <a [routerLink]="['/category', 'gachapon']"> Gachapon </a>
      </li>

      <!-- } -->
      <!-- @if (slug!=='blindbox') { -->

      <li [class.active]="slug === 'blindbox'">
        <a [routerLink]="['/category', 'blindbox']"> Blinbox </a>
      </li>

      <!-- } -->
    </ul>
  </div>

  <div class="category_product no-bg">
    @for (item of listProduct?.data; track $index) {
      <div class="container_product">
        <div class="item_product">
          <div class="item_image">
            @if (item.status === 4) {
              <div class="badge badge__onRequest">
                <span> Sobre Pedido</span>
              </div>
            }
            @if (item.status === 3) {
              <div class="badge badge__transit">
                <span> En Transito</span>
              </div>
            }
            @if (item.status === 2) {
              <div class="badge">
                <span> Preventa</span>
              </div>
            }
            @if (item.stock === 0) {
              <div class="badge badge__soldOut">
                <span> Sold Out</span>
              </div>
            }
            @if (item.status === 1 && item.stock > 0) {
              <div class="badge badge_stock">
                <span> Disponible</span>
              </div>
            }
            <a [routerLink]="['/product', item.permalink]">
              <!-- <a href="product/{{item.permalink}}"> -->
              <!-- @for (img of item.images; track $index) {
                        @switch (img.size) {
                        @case (1000) {
                        <img [src]="img.src" [alt]="item.name" class="img_lg" />
                        }
                        @case (500) {
                        <img [src]="img.src" [alt]="item.name" class="img_md 500" width="500" loading="lazy"/>
                        }
                        @case (250) {
                        <img [src]="img.src" [alt]="item.name" class="img_sm 250"  width="250"  loading="lazy"/>
                        }
                        }
                         
                        } -->
              <img [src]="item.image[0].src | imgProductSize: size" [alt]="item.name" loading="lazy" [class.soldOut]="item.stock === 0" />
              <!-- <img src="./assets/img/cyber_monday.png" alt="icon cybermonday" loading="lazy" class="cyber" /> -->
              <!-- <img [src]="item.image[0].src" [alt]="item.name" /> -->
              <!-- <img [src]="item.image[0].src"  srcset="100w, 200w, 300w" sizes="50vw" width="1000" height="1000"  [alt]="item.name"  />
                        <img [src]="item.image[0].src" srcset="100w, 200w, 300w" sizes="50vw" width="1000" height="1000"  [alt]="item.name"  /> -->
            </a>
          </div>

          <div class="item_desctiptions">
            <p>
              <a [routerLink]="['/product', item.permalink]">
                <!-- <a href="product/{{item.permalink}}"> -->
                {{ item.name }}
              </a>
            </p>
          </div>
          <div class="item_price">
            @for (price of item.price_currency; track $index) {
              <!-- <a [routerLink]="['/product', item.permalink]">

                <p>{{ price.regular_price | currency }}</p>
              </a> -->
              @if (price.sale_price > 0) {
                <a [routerLink]="['/product', item.permalink]">
                  <p class="mb-2 sale">{{ price.regular_price | currency }} {{ price.currency }}</p>
                  <p class="mb-2 ofert">{{ price.sale_price | currency }} {{ price.currency }}</p>
                </a>
              } @else {
                <a [routerLink]="['/product', item.permalink]">
                  <p class="mb-2">{{ price.regular_price | currency }} {{ price.currency }}</p>
                </a>
              }
            }
          </div>
        </div>
      </div>
    }

    <!-- <div class="container_product">
            <div class="item_product">
                <div class="item_image">
                    <img src="../img/gasha31_knave.webp">
                    <img src="../img/gasha31_knave.webp">
                </div>

                <div class="item_desctiptions">
                    <p>100% Mega Space Molly Series Blind Box by Kenny Wong</p>
                </div>
                <div class="item_price">
                    <p>$5000.00</p>
                </div>
            </div>
        </div>
        <div class="container_product">
            <div class="item_product">
                <div class="item_image">
                    <img src="../img/gasha31_knave.webp">
                    <img src="../img/gasha31_knave.webp">
                </div>

                <div class="item_desctiptions">
                    <p>100% Mega Space Molly Series Blind Box by Kenny Wong</p>
                </div>
                <div class="item_price">
                    <p>$5000.00</p>
                </div>
            </div>
        </div>
        <div class="container_product">
            <div class="item_product">
                <div class="item_image">
                    <img src="../img/gasha31_knave.webp">
                    <img src="../img/gasha31_knave.webp">
                </div>

                <div class="item_desctiptions">
                    <p>100% Mega Space Molly Series Blind Box by Kenny Wong</p>
                </div>
                <div class="item_price">
                    <p>$5000.00</p>
                </div>
            </div>
        </div> -->
  </div>
</div>
